var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultTextNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 179087",
    transform: "translate(-82 -164)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 146603",
    width: 32,
    height: 32,
    rx: 6,
    transform: "translate(82 164)",
    style: {
      fill: "#f2f6fa",
      opacity: 0.001
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29611",
    d: "M4.371 3.371v2.275a.661.661 0 0 1-1.321 0V2.711a.66.66 0 0 1 .661-.661h11.743a.66.66 0 0 1 .661.661v2.935a.661.661 0 0 1-1.321 0V3.371h-4.4V16.73h1.768a.661.661 0 0 1 0 1.321H7.02a.661.661 0 0 1 0-1.321h1.755V3.371z",
    transform: "translate(88.418 169.949)",
    style: {
      fill: "#231f20",
      fillRule: "evenodd"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultTextNewIcon);
export default __webpack_public_path__ + "static/media/default_text_new_icon.64ea55d33e0074a606350418d26e3f35.svg";
export { ForwardRef as ReactComponent };